export default {
  ADMIN_RESTRICTED_ACTION: 'Only moderators are allowed to perform this action. Request the room owner for permission.'
}
